import { dictWithUrl } from '@/components/lots/api.js'
import {
    phoneVerify,
    carLwhVerify,
    carInnerLwhVerify,
    tenIntegerVerify,
    sixTwentyIntegerVerify,
} from '../../../../../../constant/formRegular.js'
export const vehiclePublicForm = {
    propertyNature: '',
    supplierCode: '',
    licensePlateNo: '',
    vehicleType: '',
    length: '',
    lengthNameCn: '',
    lengthInteriorLength: '',
    lengthInteriorWidth: '',
    lengthInteriorHeight: '',
    insideLength: null,
    insideWidth: null,
    insideHeight: null,
    fuyouLengthKey: '',
    lengthMaxVolume: '',
    lengthMaxWeight: '',
    carOwnerType: '',
    grossWeight: '',
    carOwner: '',
    carOwnerPhone: '',
    commonDriverCode: '',
    commonDriver: '',
    commonDriverPhone: '',
    deviceNo: '',
    roadTransportNo: '',
    delegateNo: '',
    affiliatedFileId: '',
    affiliatedFileNo: '',
    affiliatedFileName: '',
    affiliatedFileUrl: '',
    affiliatedStartTime: '',
    affiliatedEndTime: '',
    roadTransportFileId: '',
    roadTransportFileName: '',
    roadTransportFileUrl: '',
    roadTransportStartTime: '',
    roadTransportEndTime: '',
    photosVehicleFileId: '', // 车辆照片id
    photosVehicleFileName: '', // 车辆照片name
    photosVehicleFileUrl: '', // 车辆照片url
    carDrivingFileId: '',
    carDrivingFileName: '',
    carDrivingFileUrl: '',
    carDrivingStartTime: '',
    carDrivingEndTime: '',
    trafficInsuranceFileId: '',
    trafficInsuranceFileName: '',
    trafficInsuranceFileUrl: '',
    trafficInsuranceStartTime: '',
    trafficInsuranceEndTime: '',
    businessInsuranceFileId: '',
    businessInsuranceFileName: '',
    businessInsuranceFileUrl: '',
    businessInsuranceStartTime: '',
    businessInsuranceEndTime: '',
    totalWeight: '', // 总质量
    mainVehicleType: '', // 车辆类型
    energyType: '', // 车辆能源类型
    licensePlateColor: '', // 车牌颜色
    mainUserCharacter: '', // 使用性质
    mainModel: '', // 品牌型号
    mainVin: '', // 车辆识别代码
    carDrivingAuthority: '', // 行驶证发证机关
    mainRegisterDate: '', // 注册日期（行驶证）
    mainIssueDate: '', // 发证日期（行驶证）
    capacity: '', // 核载人数
    outlineSize: '', // 外廓尺寸
    inspectionRecord: '', // 检验记录
    carDrivingBottomFileId: '', // 行驶证正副背面
    carDrivingBottomFileName: '',
    carDrivingBottomFileUrl: '',
    carAge: '', // 车龄
    vehicleEmissionsStandards: '', // 车辆排放标准
    axlesNum: '', // 轴数
    otherInformation: [], // 其他信息
    otherInformationExplain: '', // 其他信息补充说明
    trailerDrivingEndDate: '', // 超牌到期日期
}
// 当前日期是否大于行驶证有效日期
const driveEffectiveDate = (rule, value, callback) => {
    const timestamp = new Date(value).getTime() // 获取的截止时间戳
    const time = new Date().getTime() // 获取的当前时间
    if (timestamp - time <= 0) {
        callback(new Error('行驶证必须大于当前时间'))
    } else {
        callback()
    }
}
// 当前日期是否大于委派函有效日期
const delegatedEffectiveDate = (rule, value, callback) => {
    if (!value) {
        callback()
    }
    const timestamp = new Date(value).getTime() // 获取的截止时间戳
    const time = new Date().getTime() // 获取的当前时间
    if (timestamp - time <= 0) {
        callback(new Error('委派函必须大于当前时间'))
    } else {
        callback()
    }
}
// 当前日期是否大于道路运输证有效日期
const roadEffectiveDate = (rule, value, callback) => {
    if (!value) {
        callback()
    }
    const timestamp = new Date(value).getTime() // 获取的截止时间戳
    const time = new Date().getTime() // 获取的当前时间
    if (timestamp - time <= 0) {
        callback(new Error('道路运输证必须大于当前时间'))
    } else {
        callback()
    }
}
// 当前日期是否大于挂靠证明有效日期
const affiliatedEffectiveDate = (rule, value, callback) => {
    if (!value) {
        callback()
    }
    const timestamp = new Date(value).getTime() // 获取的截止时间戳
    const time = new Date().getTime() // 获取的当前时间
    if (timestamp - time <= 0) {
        callback(new Error('挂靠证明必须大于当前时间'))
    } else {
        callback()
    }
}

// 整备质量 1000-100000 数值
const grossWeightValidate = (rule, value, callback) => {
    if (!value) {
        callback()
    }
    const regex = /^\d+$|^\d+[.]?\d+$/
    if (regex.test(value) && parseFloat(value) <= 100000 && parseFloat(value) >= 1000) {
        callback()
    } else {
        callback(new Error('请输入数值范围1000KG≤整备质量≤ 100000KG'))
    }
}
// 车牌号字典校验
const carNumDictVerify = async(rule, value, callback) => {
    if (!value) {
        callback()
    }

    const plateSerial = (await dictWithUrl('SRM_LICENSE_PLATE_SERIAL')).data.SRM_LICENSE_PLATE_SERIAL
    const licensePlateSuffix = (await dictWithUrl('LICENSE_PLATE_SUFFIX')).data.LICENSE_PLATE_SUFFIX
    const list = []
    let listStr = '挂学警港澳超'
    for (const key in licensePlateSuffix) {
        const plate = licensePlateSuffix[key]
        list.push(plate)
    }
    if (Array.isArray(list) && list.length) {
        listStr = list.join('')
    }
    const _carNumVerify = `^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9${listStr}]{1}$`
    const carNumVerify = new RegExp(_carNumVerify.replace(/(\r\n)|(\n)/g, ''))
    let flag = false
    for (const code in plateSerial) {
        if (code && value.indexOf(plateSerial[code].trim()) === 0 && carNumVerify.test(value)) {
            flag = true
        }
    }
    if (flag) {
        callback()
    } else {
        callback(new Error('请输入正确格式的车牌号'))
    }
}
const carOwnerValidate = (rule, value, callback) => {
    if (!value) {
        callback()
    }
    const letterRegex = /^[a-zA-Z]+$/
    const numberRegex = /^\d+$/
    if (letterRegex.test(value) || numberRegex.test(value)) {
        callback(new Error('请输入正确格式的车辆所有人'))
    } else {
        callback()
    }
}

const carSizeValidate = reg => {
    return (rule, value, callback) => {
        if (['', null, undefined].includes(value)) {
            callback()
        }
        if (!reg.test(value) || +value <= 0) {
            callback(new Error('输入格式不正确'))
        } else {
            callback()
        }
    }
}

export const vehicleRules = {
    licensePlateNo: [
        { required: true, message: '请输入车牌号码', trigger: ['blur', 'change'] },
        { validator: carNumDictVerify, message: '请输入正确格式的车牌号', trigger: ['blur', 'change'] },
    ],
    lengthNameCn: [{ required: true, message: '请选择车型', trigger: ['blur', 'change'] }],
    lengthInteriorLength: [
        { required: true, message: '请输入外径长度', trigger: ['blur', 'change'] },
        { validator: carSizeValidate(carLwhVerify), message: '输入格式不正确', trigger: ['blur', 'change'] },
    ],
    lengthInteriorWidth: [
        { required: true, message: '请输入外径宽度', trigger: ['blur', 'change'] },
        { validator: carSizeValidate(carLwhVerify), message: '输入格式不正确', trigger: ['blur', 'change'] },
    ],
    lengthInteriorHeight: [
        { required: true, message: '请输入外径高度', trigger: ['blur', 'change'] },
        { validator: carSizeValidate(carLwhVerify), message: '输入格式不正确', trigger: ['blur', 'change'] },
    ],
    // 内径长度
    insideLength: [
        { required: true, message: '请输入内径长度', trigger: ['blur', 'change'] },
        { validator: carSizeValidate(carInnerLwhVerify), message: '输入格式不正确', trigger: ['blur', 'change'] },
    ],
    // 内径宽度
    insideWidth: [
        { required: true, message: '请输入内径宽度', trigger: ['blur', 'change'] },
        { validator: carSizeValidate(carInnerLwhVerify), message: '输入格式不正确', trigger: ['blur', 'change'] },
    ],
    // 内径高度
    insideHeight: [
        { required: true, message: '请输入内径高度', trigger: ['blur', 'change'] },
        { validator: carSizeValidate(carInnerLwhVerify), message: '输入格式不正确', trigger: ['blur', 'change'] },
    ],
    lengthMaxWeight: [
        { required: true, message: '请输入核定载重量', trigger: ['blur', 'change'] },
        { pattern: tenIntegerVerify, message: '不能超过10位数字', trigger: ['blur', 'change'] },
    ],
    grossWeight: [
        { required: true, message: '请输入整备质量', trigger: ['blur', 'change'] },
        { validator: grossWeightValidate, message: '1000KG≤ 整备质量≤ 100000KG', trigger: ['blur', 'change'] },
    ],
    carOwner: [
        { required: true, message: '请输入车辆所有人', trigger: ['blur', 'change'] },
        { max: 60, message: '不能输入超过60个字符', trigger: ['blur', 'change'] },
        { validator: carOwnerValidate, message: '请输入正确格式的车辆所有人', trigger: ['blur', 'change'] },
    ],
    carOwnerPhone: [
        { required: true, message: '请输入车辆所有人手机号码', trigger: ['blur', 'change'] },
        { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
    ],
    // commonDriver: [
    //     { required: true, message: '请选择车辆常用司机一', trigger: ['blur', 'change'] }
    // ],
    commonDriverPhone: [
        // { required: true, message: '请输入常用司机一手机', trigger: ['blur', 'change'] },
        { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
    ],
    deviceNo: [{ required: false, message: '', trigger: ['blur', 'change'] }],
    delegateEndTime: [
        { required: false, message: '请选择委派函有效期', trigger: ['blur', 'change'] },
        { validator: delegatedEffectiveDate, message: '委派函必须大于当前时间', trigger: ['blur', 'change'] },
    ],
    roadTransportFileName: [{ required: false, message: '请上传道路运输证', trigger: ['blur', 'change'] }],
    roadTransportEndTime: [
        { required: false, message: '请选择道路运输证有效期', trigger: ['blur', 'change'] },
        { validator: roadEffectiveDate, message: '道路运输证必须大于当前时间', trigger: ['blur', 'change'] },
    ],
    carDrivingFileName: [{ required: true, message: '请上传行驶证正副面', trigger: ['blur', 'change'] }],
    carDrivingBottomFileName: [{ required: true, message: '请上传行驶证年审页', trigger: ['blur', 'change'] }],
    carDrivingEndTime: [
        { required: true, message: '请选择行驶证有效期', trigger: ['blur', 'change'] },
        { validator: driveEffectiveDate, message: '行驶证必须大于当前时间', trigger: ['blur', 'change'] },
    ],
    totalWeight: [
        { required: true, message: '请输入总质量', trigger: ['blur', 'change'] },
        { pattern: tenIntegerVerify, message: '不能超过10位数字', trigger: ['blur', 'change'] },
    ],
    mainVehicleType: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
    energyType: [{ required: true, message: '请输入车辆能源类型', trigger: ['blur', 'change'] }],
    licensePlateColor: [{ required: true, message: '请输入车牌颜色', trigger: ['blur', 'change'] }],
    businessName: [{ required: false, message: '请输入业户名称', trigger: ['blur', 'change'] }],
    roadTransportNo: [
        { required: false, message: '请输入道路运输证号', trigger: ['blur', 'change'] },
        { pattern: sixTwentyIntegerVerify, message: '请输入6-20位数字', trigger: ['blur', 'change'] },
    ],
    affiliatedFileName: [{ required: false, message: '请上传挂靠证明', trigger: ['blur', 'change'] }],
    affiliatedEndTime: [
        { required: false, message: '请选择挂靠证明有效期', trigger: ['blur', 'change'] },
        { validator: affiliatedEffectiveDate, message: '挂靠证明必须大于当前时间', trigger: ['blur', 'change'] },
    ],
    mainUserCharacter: [
        { required: true, message: '请输入使用性质', trigger: ['blur', 'change'] },
        { max: 60, message: '不能输入超过60个字符', trigger: ['blur', 'change'] },
    ],
    mainVin: [{ required: true, message: '请输入车辆识别代码', trigger: ['blur', 'change'] }],
    carDrivingAuthority: [{ required: true, message: '请输入行驶证发证机关', trigger: ['blur', 'change'] }],
    mainRegisterDate: [{ required: true, message: '请选择行驶证注册日期', trigger: ['blur', 'change'] }],
    mainIssueDate: [{ required: true, message: '请选择行驶证发证日期', trigger: ['blur', 'change'] }],
    trailerLicensePlateNo: [
        { validator: carNumDictVerify, message: '请输入正确格式的车牌号', trigger: ['blur', 'change'] },
    ],
}

export const bringOutFieldsConfig = [
    { field: 'licensePlateNo', type: 'text' },
    { field: 'mainVehicleType', type: 'text' },
    { field: 'mainUserCharacter', type: 'text' },
    { field: 'mainModel', type: 'text' },
    { field: 'mainVin', type: 'text' },
    { field: 'capacity', type: 'text' },
    { field: 'outlineSize', type: 'text' },
    { field: 'inspectionRecord', type: 'text' },
    { field: 'carOwner', type: 'text' },
    // { field: 'carOwnerPhone', type: 'text' },
    { field: 'energyType', type: 'text' },
    { field: 'fuyouLengthKey', type: 'text' },
    // { field: 'roadTransportNo', type: 'text' },
    { field: 'carDrivingAuthority', type: 'text' },
    // { field: 'lengthNameCn', type: 'text' },
    // { field: 'length', type: 'text' },
    // { field: 'licensePlateColor', type: 'text' },
    { field: 'lengthInteriorHeight', type: 'text' },
    // { field: 'lengthInteriorLength', type: 'text' },
    // { field: 'lengthInteriorWidth', type: 'text' },
    { field: 'lengthMaxWeight', infoField: 'loadQuality', type: 'weight' },
    { field: 'grossWeight', infoField: 'emptyWeight', type: 'weight' },
    { field: 'totalWeight', infoField: 'totalWeight', type: 'weight' },
    // { field: 'carDrivingBottomFileName', type: 'text' },
    // { field: 'carDrivingBottomFileUrl', type: 'text' },
    // { field: 'carDrivingBottomFileId', type: 'text' },
    // { field: 'roadTransportFileName', type: 'text' },
    // { field: 'roadTransportFileUrl', type: 'text' },
    // { field: 'roadTransportFileId', type: 'text' },
    // { field: 'trafficInsuranceFileName', type: 'text' },
    // { field: 'trafficInsuranceFileUrl', type: 'text' },
    // { field: 'trafficInsuranceFileId', type: 'text' },
    // { field: 'businessInsuranceFileName', type: 'text' },
    // { field: 'businessInsuranceFileUrl', type: 'text' },
    // { field: 'businessInsuranceFileId', type: 'text' },
    { field: 'mainRegisterDate', type: 'date' },
    { field: 'mainIssueDate', type: 'date' },
    // { field: 'roadTransportEndTime', type: 'date' }, // OCR未能返回该字段，待确认是否去除
    // { field: 'carDrivingEndTime', type: 'date' },
    // { field: 'trafficInsuranceEndTime', type: 'date' }, // OCR未能返回该字段，待确认是否去除
    // { field: 'businessInsuranceEndTime', type: 'date' }, // OCR未能返回该字段，待确认是否去除
]
